var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { ReportClient, UsersClient, CompaniesClient, GetReportListQuery, GetUserListQuery, GetReportPermissionUsersQuery, UpsertReportUserPermissionsCommand, UpsertReportsUserPermissionsModel, UpsertReportUserPermissionsModel, RoleTypeEnum, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import Sorter from "@/common/utils/sorter";
const companyClient = new CompaniesClient(window.apiUrl);
const reportClient = new ReportClient(window.apiUrl);
const usersClient = new UsersClient(window.apiUrl);
let SitesVue = class SitesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.companyId = null;
        this.showOnlyUsersSelected = false;
        this.userFilter = "";
        this.companies = [];
        this.reports = new Array();
        this.selectedReport = null;
        this.users = new Array();
        this.usersAllowed = {};
        this.originalReports = new Array();
        this.originalUsersAllowed = {};
        this.sorter = new Sorter(new SortDescription({
            fieldName: "reportName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetReportListQuery({
            sort: this.sorter.currentSort
        });
        this.lastCompanyId = null;
    }
    created() {
        this.getData();
    }
    ;
    getData() {
        this.getCompanies();
        this.getReports();
    }
    ;
    getCompanies() {
        this.working = true;
        companyClient
            .getListGET()
            .then(response => {
            this.companies = (response || []).map((item) => {
                return {
                    value: item.companyId,
                    text: item.companyName || ""
                };
            });
            if (!this.companies.length)
                return;
            if (this.companyId)
                return;
            this.companyId = this.companies[0].value;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getReports() {
        this.working = true;
        reportClient.getReportList(this.query).then((response) => {
            this.reports = response;
            try {
                this.originalReports = structuredClone(response);
            }
            catch (e) {
                console.error(e);
            }
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    getUsers() {
        this.working = true;
        this.usersPromise = usersClient
            .getListPOST(new GetUserListQuery({ keywords: "", includeDeletes: false, roleIds: [RoleTypeEnum.Client], companyId: this.companyId })).then((response) => {
            this.users = response;
            this.clearChanges();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    loadPermissions() {
        if (this.working)
            return;
        if (!this.selectedReport)
            return;
        if (this.reportUserAllowed)
            return;
        this.working = true;
        reportClient
            .getReportCompanyPermissions(new GetReportPermissionUsersQuery({ reportId: this.selectedReport.reportId, companyId: this.companyId }))
            .then((response) => {
            if (!response)
                return;
            this.selectedReport.denyAccessToUsers = response.denyAcccesToUsers;
            this.reportUserAllowed = this.users.filter(user => { var _a; return (_a = response.userIds) === null || _a === void 0 ? void 0 : _a.includes(user.userId); }).map(user => user.userId);
            let originalReport = this.originalReports.find(report => { var _a; return report.reportId == ((_a = this.selectedReport) === null || _a === void 0 ? void 0 : _a.reportId); });
            if (originalReport)
                originalReport.denyAccessToUsers = response.denyAcccesToUsers;
            this.originalUsersAllowed[this.selectedReport.reportId] = [...response.userIds];
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    onCompanyIdChanged(newId, oldId) {
        if (this.lastCompanyId != null) {
            this.lastCompanyId = null;
            return;
        }
        if (this.hasChanges) {
            this.$confirmModal.show("There are unsaved changes. Are you sure you want to cancel changes?")
                .then((value) => {
                try {
                    if (!value) {
                        this.lastCompanyId = oldId;
                        this.companyId = oldId;
                        return;
                    }
                    this.getUsers();
                }
                catch (e) {
                    console.error(e);
                }
            });
            return;
        }
        this.getUsers();
    }
    get usersFiltered() {
        var strFilter = this.userFilter.toLowerCase();
        return this.users
            .filter(item => { var _a, _b; return ((_a = item.displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(strFilter)) || ((_b = item.emailAddress) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(strFilter)); })
            .filter(item => !this.showOnlyUsersSelected || this.isUserSelected(item));
    }
    save() {
        if (this.working)
            return;
        this.working = true;
        var model = new UpsertReportsUserPermissionsModel();
        model.companyId = this.companyId;
        model.reports = [];
        this.reports.forEach(report => {
            var userIds = this.usersAllowed[report.reportId];
            if (userIds) {
                var item = new UpsertReportUserPermissionsModel();
                item.denyAccessToUsers = report.denyAccessToUsers;
                item.report = report;
                item.userIds = userIds;
                model.reports.push(item);
            }
        });
        reportClient
            .saveReportPermissions(new UpsertReportUserPermissionsCommand({ requestModel: model }))
            .then(() => {
            this.clearChanges();
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    cancel() {
        this.$confirmModal.show("Are you sure you want to cancel changes?")
            .then((value) => {
            try {
                if (!value)
                    return;
                this.clearChanges();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    clearChanges() {
        this.selectedReport = null;
        this.usersAllowed = {};
        this.reports.forEach(report => report.denyAccessToUsers = false);
        this.originalReports.forEach(report => report.denyAccessToUsers = false);
    }
    get hasChanges() {
        try {
            let hasChanges = false;
            this.reports.forEach(report => {
                if (hasChanges)
                    return;
                let originalReport = this.originalReports.find(x => x.reportId == report.reportId);
                hasChanges = (originalReport === null || originalReport === void 0 ? void 0 : originalReport.denyAccessToUsers) != report.denyAccessToUsers;
                if (hasChanges || !report.denyAccessToUsers)
                    return;
                var userIds = this.usersAllowed[report.reportId];
                if (userIds) {
                    let originalUserIds = this.originalUsersAllowed[report.reportId];
                    let intersection = userIds.filter(userId => originalUserIds.includes(userId));
                    hasChanges = userIds.length != originalUserIds.length || intersection.length != userIds.length;
                }
            });
            return hasChanges;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get reportUserAllowed() {
        var _a;
        if (!((_a = this.selectedReport) === null || _a === void 0 ? void 0 : _a.reportId))
            return [];
        return this.usersAllowed[this.selectedReport.reportId];
    }
    set reportUserAllowed(userIds) {
        var _a;
        if (!((_a = this.selectedReport) === null || _a === void 0 ? void 0 : _a.reportId))
            return;
        this.usersAllowed[this.selectedReport.reportId] = userIds;
    }
    isReportSelected(report) {
        return report == this.selectedReport;
    }
    selectReport(report) {
        this.selectedReport = report;
        this.loadPermissions();
    }
    isUserSelected(user) {
        return this.reportUserAllowed && this.reportUserAllowed.includes(user.userId);
    }
    selectUser(user) {
        let idx = this.reportUserAllowed.indexOf(user.userId);
        if (idx >= 0)
            this.reportUserAllowed.splice(idx, 1);
        else
            this.reportUserAllowed.push(user.userId);
    }
    get selectedUsersCount() {
        try {
            let count = () => {
                var _a;
                let userIds = this.usersAllowed[(_a = this.selectedReport) === null || _a === void 0 ? void 0 : _a.reportId];
                if (!userIds)
                    return 0;
                return userIds.length;
            };
            var selected = count();
            if (selected == 0)
                this.showOnlyUsersSelected = false;
            return selected;
        }
        catch (e) {
            console.error('selectedUsersCount', e);
        }
    }
    get selectedUsersName() {
        var _a;
        try {
            let userIds = this.usersAllowed[(_a = this.selectedReport) === null || _a === void 0 ? void 0 : _a.reportId];
            if (!userIds)
                return "";
            return this.users
                .filter(user => userIds.includes(user.userId))
                .map(user => { return user.displayName; })
                .join(', ');
        }
        catch (e) {
            console.error('selectedUsersName', e);
        }
    }
};
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], SitesVue.prototype, "onCompanyIdChanged", null);
SitesVue = __decorate([
    Component({
        name: "SitesVue"
    })
], SitesVue);
export default SitesVue;
